import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { axios } from "../../../lib/axios";

import { t, DIR } from "../../../i18n";
const RegisterPage = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [role, setRole] = useState("staff");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    // Check if passwords match before submitting
    if (password !== confirmPassword) {
      setError(t("كلمة المرور وتأكيد كلمة المرور غير متطابقين"));
      setLoading(false);
      return;
    }

    try {
      await axios.post(
        "/register",
        {
          name: name,
          username: name,
          password: password,
          password_confirmation: confirmPassword,
          role,
        },
        {
          withCredentials: true,
          headers: { "Content-Type": "application/json" },
        }
      );

      // Only owners can create accounts, and they stay signed in as themselves: the new account's token is
      // not stored.
      navigate("/home");
    } catch (err) {
      console.error("Signup error:", err);
      setError(err.response?.data?.message || t("حدث خطأ أثناء إنشاء الحساب"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="flex justify-center items-center min-h-screen bg-gradient-to-br from-brand-50 via-slate-50 to-brand-100 px-4 py-8"
      dir={DIR}
    >
      <div className="w-full max-w-lg card-hero py-10 px-6 md:px-10 flex flex-col items-center">
        {/* Header */}
        <h1 className="text-brand-700 text-2xl md:text-3xl font-bold mb-8">{t("إنشاء حساب")}</h1>

        {/* Form */}
        <form onSubmit={handleSubmit} className="w-full flex flex-col gap-4">
          {/* Name Field */}
          <div className="w-full">
            <label htmlFor="name" className="block text-slate-700 text-sm font-medium mb-2">
              {t("اسم المستخدم")}
            </label>
            <input
              id="name"
              type="text"
              placeholder={t("ادخل اسم المستخدم")}
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="field"
            />
          </div>

          {/* Email Field */}
          <div className="w-full">
            <label htmlFor="email" className="block text-slate-700 text-sm font-medium mb-2">
              {t("معرف المستخدم")}
            </label>
            <input
              id="email"
              type="text"
              placeholder={t("ادخل معرف المستخدم")}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="field"
            />
          </div>

          {/* Password Field */}
          <div className="w-full">
            <label htmlFor="password" className="block text-slate-700 text-sm font-medium mb-2">
              {t("كلمة المرور")}
            </label>
            <input
              id="password"
              type="password"
              placeholder={t("ادخل كلمة المرور")}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="field"
            />
          </div>

          {/* Confirm Password Field */}
          <div className="w-full">
            <label
              htmlFor="confirmPassword"
              className="block text-slate-700 text-sm font-medium mb-2"
            >
              {t("تأكيد كلمة المرور")}
            </label>
            <input
              id="confirmPassword"
              type="password"
              placeholder={t("ادخل تأكيد كلمة المرور")}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="field"
            />
          </div>

          {/* Error Message */}
          {error && (
            <div className="w-full rounded-lg bg-red-50 px-3 py-2 text-red-700 text-center text-sm">
              {error}
            </div>
          )}

          {/* Role */}
          <div className="w-full">
            <label htmlFor="role" className="block text-slate-700 text-sm font-medium mb-2">
              {t("الدور")}
            </label>
            <select
              id="role"
              value={role}
              onChange={(e) => setRole(e.target.value)}
              className="field"
            >
              <option value="staff">{t("موظف")}</option>
              <option value="owner">{t("مالك")}</option>
            </select>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className={`w-full h-12 bg-brand-600 rounded-xl shadow-sm text-white font-bold ${
              loading ? "opacity-60 cursor-not-allowed" : "hover:bg-brand-700 hover:shadow-md"
            }`}
            disabled={loading}
          >
            {loading ? t("جاري التحميل...") : t("إنشاء حساب")}
          </button>
        </form>

        {/* Login Link */}
        <div className="mt-6">
          <Link
            to="/login"
            className="text-brand-700 underline underline-offset-4 hover:text-brand-800"
          >
            {t("تسجيل الدخول")}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
